import { baseApi } from '../baseApi';
import { ListParams } from './academicYearApi';

export interface Video {
  id: string;
  title: string;
  description?: string | null;
  videoType: 'local' | 'external';
  platform: 'youtube' | 'other';
  url: string;
  thumbnail?: string | null;
  duration?: string | null;
  isActive: boolean;
  chapterId: string;
  subjectId: string;
  academicYearId: string;
  classId: string;
  createdAt: string;
  updatedAt: string;
  academicYear?: { name: string };
  chapter?: { name: string };
  subject?: { name: string };
}

export const videoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVideos: builder.query<{ success: boolean; data: Video[]; total: number }, ListParams | void>({
      query: (params) => ({
        url: '/api/videos',
        params: params || undefined,
      }),
      providesTags: ['Video'],
    }),
    createVideo: builder.mutation<{ success: boolean; data: Video }, Partial<Video>>({
      query: (body) => ({
        url: '/api/videos',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Video', 'Dashboard'],
    }),
    updateVideo: builder.mutation<{ success: boolean; data: Video }, { id: string; body: Partial<Video> }>({
      query: ({ id, body }) => ({
        url: `/api/videos/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Video', 'Dashboard'],
    }),
    deleteVideo: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/videos/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Video', 'Dashboard'],
    }),
    uploadVideoChunk: builder.mutation<{ success: boolean; url?: string; merged: boolean; path?: string }, { formData: FormData; folder?: string; subfolder?: string }>({
      query: ({ formData, folder, subfolder }) => ({
        url: '/api/upload/video/chunk',
        method: 'POST',
        body: formData,
        params: { folder, subfolder }
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetVideosQuery,
  useCreateVideoMutation,
  useUpdateVideoMutation,
  useDeleteVideoMutation,
  useUploadVideoChunkMutation,
} = videoApi;
